import { useCallback, useState } from "react";

export const INIT_VALUE_DEADLINES_SETTINGS = {
	included: false,
	from: null,
	to: null,
};

export const INIT_VALUE_APPROVALS_SETTINGS = {
	included: true,
	isLoading: false,
	list: [],
	selected: [],
};

const useAdditionalSettingsPrintHook = () => {
	const [deadlinesSettings, setDeadlinesSettings] = useState(INIT_VALUE_DEADLINES_SETTINGS);

	const [approvalsSettings, setApprovalsSettings] = useState(INIT_VALUE_APPROVALS_SETTINGS);

	const updateDeadlinesSettings = useCallback(
		({ ...data }) => setDeadlinesSettings((settings) => ({ ...settings, ...data })),
		[setDeadlinesSettings]
	);

	const updateApprovalsSettings = useCallback(
		({ ...data }) => setApprovalsSettings((settings) => ({ ...settings, ...data })),
		[setApprovalsSettings]
	);

	return {
		deadlinesSettings,
		updateDeadlinesSettings,
		approvalsSettings,
		updateApprovalsSettings,
	};
};

export default useAdditionalSettingsPrintHook;
